import React from 'react';
import { Outlet } from 'react-router-dom';
import useAuthStatus from '../hooks/useAuthStatus';
import { Button } from 'rsuite';
import { DriverStatus } from '../my-enum';

interface ProtectedRouteProps {
  children?: React.ReactNode;
  redirectToLogin?: boolean;
  redirectPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectToLogin = true,
  redirectPath = '/login'
}) => {
  const { loggedIn, loading, user } = useAuthStatus({
    redirectToLogin,
    redirectPath
  });

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // If not logged in, the useAuthStatus hook will handle redirection
  // But we can also provide a fallback UI if needed
  if (!loggedIn) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="text-center">
          <h5>請先登入</h5>
          <p>正在重新導向至登入頁面...</p>
        </div>
      </div>
    );
  }

  if (window.location.pathname.startsWith('/driver')) {

    if (user?.roleString.indexOf('Driver') === -1) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <div className="text-center">
            <h5>權限不足</h5>
            <br></br>
            <p>您沒有權限訪問此頁面。</p>
            <p><Button onClick={() => window.location.href = '/rider/applydriver'}>申請成為司機</Button></p>
          </div>
        </div>
      );
    } else if (user?.driver?.status === DriverStatus.未驗證) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <div className="text-center">
            <h5>司機身份審核中</h5>
            <br></br>
            <p>請耐心等待審核結果，通過後您會收到LINE官方帳號通知。</p>
            <p>若您已收到審核通過通知但狀態還是審核中請重新登入。</p>
          </div>
        </div>
      );
    } else if (user?.driver?.status === DriverStatus.停用中) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <div className="text-center">
            <h5>司機身份已停用</h5>
            <br></br>
            <p>請聯繫管理員以恢復您的身份。</p>
          </div>
        </div>
      );
    } else {
      // User is a verified driver, allow access
    }

  }

  if (window.location.pathname.startsWith('/admin')) {

    if (document.location.hostname !== user?.team.domainName || user?.roleString.indexOf('Lead') === -1) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <div className="text-center">
            <h5>權限不足</h5>
            <br></br>
            <p>您沒有權限訪問此頁面。</p>
          </div>
        </div>
      );
    } else {
      // User is an team lead, allow access
    }
  }

  // If authenticated, render children or outlet
  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;